/**
 * ============================================================================
 *  Categorias restritas (espelho de UX do backend)
 * ============================================================================
 *
 * Espelha `backend/config/restrictedCategories.js`. Aqui a regra serve apenas
 * para a EXPERIÊNCIA do usuário (mostrar/esconder links, página dedicada e
 * mensagens). A segurança de verdade é SEMPRE aplicada no backend.
 *
 *  >>> Para liberar uma NOVA categoria restrita: adicione uma entrada aqui e
 *      a entrada correspondente no backend. A rota e a página dedicada são
 *      geradas automaticamente a partir desta lista. <<<
 *
 * Campos:
 *   - id           : ID da categoria no WordPress (= Category.id local).
 *   - slug         : slug da categoria no WordPress.
 *   - field        : coluna de m_socios que concede o acesso (vem em user.data_api).
 *   - grantedValues: valores da coluna que liberam o conteúdo.
 *   - label        : título exibido na página/links.
 *   - description  : subtítulo exibido na página dedicada.
 *   - path         : rota dedicada no frontend.
 *   - routeName    : nome da rota no vue-router.
 */
export const RESTRICTED_CATEGORIES = [
  {
    id: 1742,
    slug: 'diretoria',
    field: 'agendaDiretoria',
    grantedValues: ['S', '1'],
    label: 'Diretoria da SBN',
    description: 'Conteúdos exclusivos para os membros da Diretoria da SBN.',
    path: '/diretoria',
    routeName: 'Diretoria',
  },
];

/**
 * O usuário logado tem acesso à categoria restrita?
 * Lê a permissão de `user.data_api` (registro do sócio retornado no login).
 *
 * @param {object|null} user      objeto do usuário no store (getUser).
 * @param {object} category       entrada de RESTRICTED_CATEGORIES.
 */
export function socioHasAccess(user, category) {
  if (!user || !category) return false;
  const socio = user.data_api || {};
  const value = socio[category.field];
  if (value === null || value === undefined) return false;
  return category.grantedValues.map(String).includes(String(value).trim());
}

/** Entrada de categoria restrita a partir do slug (ou null). */
export function getRestrictedBySlug(slug) {
  return RESTRICTED_CATEGORIES.find((c) => c.slug === slug) || null;
}

/** Categorias restritas que ESTE usuário pode acessar (para montar links/atalhos). */
export function getAccessibleRestricted(user) {
  return RESTRICTED_CATEGORIES.filter((c) => socioHasAccess(user, c));
}
